module.exports = __webpack_public_path__ + "img/three-step-sm.bd6565d.png";